/* eslint-disable no-undef */
const APP_VERSION = '2.11.0';

const cleanCache = () =>
  caches.keys().then(keyList => {
    keyList.forEach(key => {
      if (key.match('local')) {
        caches.delete(key).then(deleted => console.log(deleted));
      }
    });
  });

const unregisterServiceWorker = () => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(registrations => {
      registrations.forEach(registration => {
        registration.unregister();
      });
    });
  }
};

export const clearLocalStorage = () => localStorage.clear();
const setBrowserAppVersion = () => localStorage.setItem('appVersion', APP_VERSION);
const getBrowserAppVersion = localStorage.getItem('appVersion');
const isUnsettedVersion = getBrowserAppVersion === null || getBrowserAppVersion === undefined;
const areDifferentVersions = getBrowserAppVersion !== APP_VERSION;

const handleAppVersion = () => {
  if (isUnsettedVersion || areDifferentVersions) {
    clearLocalStorage();
    cleanCache();
    setBrowserAppVersion();
    unregisterServiceWorker();

    return Promise.resolve();
  }
  return Promise.resolve();
};

export default handleAppVersion;
